import { gql, useQuery } from "@apollo/client";
import dayjs, { Dayjs } from "dayjs";

const GET_ALL_YOU_CAN_SPEAK_BONUS_STATUS = gql`
  query getMyAllYouCanSpeakBonusStatus(
    $dateUtc: String!
    $clientTimezone: String!
  ) {
    getMyAllYouCanSpeakBonusStatus(
      dateUtc: $dateUtc
      clientTimezone: $clientTimezone
    ) {
      isBonusActive
      freeBookingsUnlocked
      lessonsCountedPerWeek
    }
  }
`;

type BonusStatusData = {
  getMyAllYouCanSpeakBonusStatus: {
    isBonusActive: boolean;
    freeBookingsUnlocked: boolean;
    lessonsCountedPerWeek?: number | null;
  };
};

export function useAllYouCanSpeakBonusStatus({ date }: { date: Dayjs }) {
  const { data, loading } = useQuery<BonusStatusData>(
    GET_ALL_YOU_CAN_SPEAK_BONUS_STATUS,
    {
      variables: {
        dateUtc: date.startOf("week").toISOString(),
        clientTimezone: dayjs.tz.guess(),
      },
      fetchPolicy: "cache-first",
    },
  );

  const status = data?.getMyAllYouCanSpeakBonusStatus;

  return {
    isBonusActive: status?.isBonusActive ?? false,
    freeBookingsUnlocked: status?.freeBookingsUnlocked ?? false,
    lessonsCountedPerWeek: status?.lessonsCountedPerWeek ?? undefined,
    loading,
  };
}
